class Tickertape extends HTMLElement {
  constructor() {
    super();
    this.columnSelector = ".tickertape__column";
    this.blockSelector = ".tickertape__block";
    this.type = this.dataset.type ? this.dataset.type : "horizonal";
    this.repeat = this.dataset.repeat ? Number(this.dataset.repeat) : 1;
    this.timing = this.dataset.timing ? Number(this.dataset.timing) : 16;
    this.delay = this.dataset.delay ? Number(this.dataset.delay) : 0;
    this.staggered = this.dataset.staggered == "true" ? true : false;
    this.columns = this.querySelectorAll(this.columnSelector);
    this.started = false;
    this.columns.forEach((column, index) => {
      const item = column.querySelector(this.blockSelector);
      this.handleLoop(column, item, index);
    });
  }
  animateTickertape(elem, item, options) {
    const index = options.count;
    const el = elem;
    const { distance } = options;
    let index1 = index + 1;
    el.style.transitionTimingFunction = "linear";
    el.style.transitionProperty = "all";
    if (this.type == "vertical" && this.staggered) {
      if (index1 === 1) {
        index1 = 1;
      }
      if (index1 === 2) {
        index1 = 4;
      }
      if (index1 === 3) {
        index1 = 3;
      }
      if (index1 === 4) {
        index1 = 2;
      }
      el.style.transitionDuration = `${(index1 + 1) * this.timing}s`;
      el.style.transform = `translate3d(0, -${distance}px, 0)`;
    } else if (this.type == "vertical") {
      el.style.transitionDuration = `${this.timing}s`;
      el.style.transform = `translate3d(0, -${distance}px, 0)`;
    } else {
      el.style.transitionDuration = `${this.timing}s`;
      el.style.transform = `translate3d(-${distance}px, 0,  0)`;
    }
    const resetTimer = this.staggered ? (index1 + 1) * (this.timing * 1e3) : this.timing * 1e3;
    window.setTimeout(() => {
      el.style.transitionDuration = "0s";
      el.style.transform = `translate3d(0, 0 ,0)`;
      this.handleLoop(elem, item, index);
    }, resetTimer);
  }
  handleLoop(wrap, item, index) {
    if (!this.started) {
      setTimeout(() => {
        this.started = true;
        let distance = this.type == "vertical" ? wrap.getBoundingClientRect().height : item.getBoundingClientRect().width;
        if (this.repeat) {
          distance = distance * this.repeat;
        }
        this.animateTickertape(wrap, item, { distance, count: index });
      }, this.delay);
    } else {
      let distance = this.type == "vertical" ? wrap.getBoundingClientRect().height : item.getBoundingClientRect().width;
      if (this.repeat) {
        distance = distance * this.repeat;
      }
      this.animateTickertape(wrap, item, { distance, count: index });
    }
  }
}
if (!customElements.get("ticker-tape")) {
  customElements.define("ticker-tape", Tickertape);
}
export {
  Tickertape,
  Tickertape as default
};
